import { BiLoaderAlt } from "react-icons/bi";

export const SubmitLoader = () => {
    return (
        <div className="text-white d-inline pr-3 submitLoader">
           <BiLoaderAlt />
        </div>
    );
}
